import { Observable, of } from 'rxjs';
import { AuthzNgRxAwareService } from './authz.service';
export class AuthzStubService extends AuthzNgRxAwareService {

  constructor() {
    super();
  }

  lireListeTraitements(): Observable<string[]> {
    return of(['.+']);
  }

  lireListePerimetres(): Observable<string[]> {
    return of(['PER-ADM']);
  }

  hasTraitement(traitement: string): Observable<boolean> {
    return of(true);
  }

  lireListeModules(): Observable<string[]> {
    return of(['.+']);
  }

  hasAccessToModule(moduleName: string): Observable<boolean> {
    return of(true);
  }

  hasAccessToAnyModule(module: string[]): Observable<boolean> {
    return of(true);
  }
}
